<!-- student-account-entity.component.html -->
<h1 class="page-header" *ngIf="!embedded">Create Student Account</h1>

<div [ngClass]="{
        'loading-shade': showProgressSpinner
     }">

        <mat-progress-spinner class="matProgressSpinnerCentered" *ngIf="showProgressSpinner" mode="indeterminate">
        </mat-progress-spinner>

        <div>
            <div>

                <!-- Form -->
                <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form" >

                        <div class="container">

                            <div class="row">
                                <mat-card>

                                    <!-- The student. Same fields and groups as
                                         the inquiry form's contact section. -->
                                    <div #firstContact="ngModelGroup" ngModelGroup="__field_contact_inline_form">

                                        <input class="d-none" ngModel name="type" matInput>
                                        <input class="d-none" ngModel name="bundle" matInput>

                                        <h3 class="h6 text-uppercase text-muted fw-semibold mb-2">Contact information</h3>

                                        <div class="row">
                                            <div class="col-md-6">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>First Name</mat-label>
                                                    <input name="field_first_name" required matInput ngModel (ngModelChange)="checkDuplicateStudent('main')">
                                                </mat-form-field>
                                            </div>

                                            <div class="col-md-6">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>Last Name</mat-label>
                                                    <input name="field_last_name" required matInput ngModel (ngModelChange)="checkDuplicateStudent('main')">
                                                </mat-form-field>
                                            </div>

                                            <div class="col-12" *ngIf="duplicateWarning">
                                                <div class="alert alert-warning d-flex align-items-center">
                                                    <mat-icon class="me-2">warning</mat-icon>
                                                    <span>{{ duplicateWarning }}</span>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>Email Address</mat-label>
                                                    <input required type="email"
                                                        ngModel name="field_email"
                                                        #fieldEmail="ngModel"
                                                        pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                        matInput>
                                                    <mat-error *ngIf="fieldEmail.invalid && (fieldEmail.dirty || fieldEmail.touched)">
                                                        Please enter a valid email address
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-6 mt-2">
                                                <div class="small text-muted mb-1">Lead/Follow *</div>
                                                <mat-radio-group name="field_lead_follow" required ngModel aria-label="Lead/Follow" class="d-flex gap-3">
                                                    <mat-radio-button value="lead">Lead</mat-radio-button>
                                                    <mat-radio-button value="follow">Follow</mat-radio-button>
                                                </mat-radio-group>
                                            </div>


                                            <div class="col-md-6 phone-field-wrapper mt-2">
                                                <label class="phone-label">Home Phone</label>
                                                <ngx-intl-tel-input
                                                    [cssClass]="'form-control'"
                                                    [preferredCountries]="['us', 'ca', 'gb', 'au', 'nz', 'de', 'fr', 'es', 'it']"
                                                    [enableAutoCountrySelect]="false"
                                                    [enablePlaceholder]="true"
                                                    [searchCountryFlag]="true"
                                                    [searchCountryPlaceholder]="'Search Country'"
                                                    [selectFirstCountry]="false"
                                                    [selectedCountryISO]="selectedCountry?.toLowerCase()"
                                                    [phoneValidation]="false"
                                                    [separateDialCode]="true"
                                                    name="field_home_phone"
                                                    ngModel>
                                                </ngx-intl-tel-input>
                                            </div>

                                            <div class="col-md-6 phone-field-wrapper mt-2">
                                                <label class="phone-label">Cell Phone</label>
                                                <ngx-intl-tel-input
                                                    [cssClass]="'form-control'"
                                                    [preferredCountries]="['us', 'ca', 'gb', 'au', 'nz', 'de', 'fr', 'es', 'it']"
                                                    [enableAutoCountrySelect]="false"
                                                    [enablePlaceholder]="true"
                                                    [searchCountryFlag]="true"
                                                    [searchCountryPlaceholder]="'Search Country'"
                                                    [selectFirstCountry]="false"
                                                    [selectedCountryISO]="selectedCountry?.toLowerCase()"
                                                    [phoneValidation]="false"
                                                    [separateDialCode]="true"
                                                    name="field_cell_phone"
                                                    ngModel>
                                                </ngx-intl-tel-input>
                                            </div>


                                            <div class="col-md-6" *ngIf="showFiscalCode">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>{{ 'PAYMENTS.FISCAL_CODE' | translate }}</mat-label>
                                                    <input ngModel name="field_fiscal_code" maxlength="16" matInput>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <!-- Address  -->
                                        <div ngModelGroup="field_address" #mainAddress="ngModelGroup">

                                            <input
                                                class="d-none"
                                                name="multiple_properties"
                                                matInput
                                                ngModel="true">

                                            <!-- Collapsed until needed; the header summarises the address once one is entered. -->
                                            <mat-expansion-panel class="mt-4">
                                                <mat-expansion-panel-header>
                                                    <mat-panel-title class="h6 text-uppercase text-muted fw-semibold mb-0">Address</mat-panel-title>
                                                    <mat-panel-description class="text-truncate">{{ addressSummary(mainAddress.value) || 'Optional' }}</mat-panel-description>
                                                </mat-expansion-panel-header>

                                            <div class="row">
                                                <div class="col-12">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>Street Address</mat-label>
                                                        <input ngModel name="address_line1" matInput>
                                                    </mat-form-field>
                                                </div>

                                                <div class="col-md-5">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>City</mat-label>
                                                        <input ngModel name="locality" matInput>
                                                    </mat-form-field>
                                                </div>

                                                <div class="col-md-5">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>{{ administrativeAreaLabel }}</mat-label>
                                                        <mat-select matInput ngModel name="administrative_area" *ngIf="internationalAddressService.hasAdministrativeAreas(selectedCountry)">
                                                            <mat-option>None</mat-option>
                                                            <mat-option *ngFor="let area of internationalAddressService.getAdministrativeAreas(selectedCountry)"
                                                                [value]="area.abbreviation">
                                                                {{ area.name }}</mat-option>
                                                        </mat-select>
                                                        <input matInput ngModel name="administrative_area" *ngIf="!internationalAddressService.hasAdministrativeAreas(selectedCountry)">
                                                    </mat-form-field>
                                                </div>

                                                <div class="col-md-2">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>{{ postalCodeLabel }}</mat-label>
                                                        <input ngModel name="postal_code" matInput>
                                                    </mat-form-field>
                                                </div>

                                                <div class="col-12">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>Country</mat-label>
                                                        <mat-select [(ngModel)]="selectedCountry" name="country_code" (ngModelChange)="onCountryChange($event)">
                                                            <mat-option *ngFor="let country of this._fieldsService.countries" [value]="country.abbreviation">
                                                                {{ country.name }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            </mat-expansion-panel>
                                        </div>

                                        <div class="row mt-3">
                                            <div class="col-12">
                                                <p class="small mb-1">Consenting below permits Arthur Murray International, Inc. to send you text messages about appointments, updates, and promotional offers. No purchase is necessary, and you can opt out anytime by texting STOP. Message and data rates may apply.</p>
                                                <mat-checkbox [ngModel]="field_communication_opt_in" (ngModelChange)="onCommunicationOptInChange($event)" name="field_communication_opt_in" class="small">
                                                    Consent Given
                                                </mat-checkbox>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mt-4">
                                        <div class="small text-muted mb-1">Attending Lessons</div>
                                        <mat-button-toggle-group name="field_attending_lessons" [(ngModel)]="field_attending_lessons" (change)="onAttendingLessonsChange($event)" aria-label="Attending Lessons">
                                            <mat-button-toggle value="solo">
                                                <mat-icon>person</mat-icon>
                                                Solo
                                            </mat-button-toggle>
                                            <mat-button-toggle value="partner">
                                                <mat-icon>people</mat-icon>
                                                With Partner
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>

                                    <!-- The partner, shown only when they attend together. -->
                                    <ng-template [ngIf]="field_attending_lessons === 'partner'">
                                        <div class="mt-4" ngModelGroup="__partner_contact_inline_form" #partnerContact="ngModelGroup">

                                            <input class="d-none" ngModel name="type" matInput>
                                            <input class="d-none" ngModel name="bundle" matInput>

                                            <h3 class="h6 text-uppercase text-muted fw-semibold mb-2">Partner information</h3>

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>First Name</mat-label>
                                                        <input name="field_first_name" required matInput ngModel (ngModelChange)="checkDuplicateStudent('partner')">
                                                    </mat-form-field>
                                                </div>

                                                <div class="col-md-6">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>Last Name</mat-label>
                                                        <input name="field_last_name" required matInput ngModel (ngModelChange)="checkDuplicateStudent('partner')">
                                                    </mat-form-field>
                                                </div>

                                                <div class="col-12" *ngIf="duplicateWarningPartner">
                                                    <div class="alert alert-warning d-flex align-items-center">
                                                        <mat-icon class="me-2">warning</mat-icon>
                                                        <span>{{ duplicateWarningPartner }}</span>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>Email Address</mat-label>
                                                        <input type="email"
                                                            ngModel name="field_email"
                                                            #partnerEmail="ngModel"
                                                            pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                            matInput>
                                                        <mat-error *ngIf="partnerEmail.invalid && (partnerEmail.dirty || partnerEmail.touched)">
                                                            Please enter a valid email address
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                                <div class="col-md-6 mt-2">
                                                    <div class="small text-muted mb-1">Lead/Follow *</div>
                                                    <mat-radio-group name="field_lead_follow_partner" required ngModel aria-label="Lead/Follow" class="d-flex gap-3">
                                                        <mat-radio-button value="lead">Lead</mat-radio-button>
                                                        <mat-radio-button value="follow">Follow</mat-radio-button>
                                                    </mat-radio-group>
                                                </div>


                                                <div class="col-md-6 phone-field-wrapper mt-2">
                                                    <label class="phone-label">Home Phone</label>
                                                    <ngx-intl-tel-input
                                                        [cssClass]="'form-control'"
                                                        [preferredCountries]="['us', 'ca', 'gb', 'au', 'nz', 'de', 'fr', 'es', 'it']"
                                                        [enableAutoCountrySelect]="false"
                                                        [enablePlaceholder]="true"
                                                        [searchCountryFlag]="true"
                                                        [searchCountryPlaceholder]="'Search Country'"
                                                        [selectFirstCountry]="false"
                                                        [selectedCountryISO]="selectedCountryPartner?.toLowerCase()"
                                                        [phoneValidation]="false"
                                                        [separateDialCode]="true"
                                                        name="field_home_phone"
                                                        ngModel>
                                                    </ngx-intl-tel-input>
                                                </div>

                                                <div class="col-md-6 phone-field-wrapper mt-2">
                                                    <label class="phone-label">Cell Phone</label>
                                                    <ngx-intl-tel-input
                                                        [cssClass]="'form-control'"
                                                        [preferredCountries]="['us', 'ca', 'gb', 'au', 'nz', 'de', 'fr', 'es', 'it']"
                                                        [enableAutoCountrySelect]="false"
                                                        [enablePlaceholder]="true"
                                                        [searchCountryFlag]="true"
                                                        [searchCountryPlaceholder]="'Search Country'"
                                                        [selectFirstCountry]="false"
                                                        [selectedCountryISO]="selectedCountryPartner?.toLowerCase()"
                                                        [phoneValidation]="false"
                                                        [separateDialCode]="true"
                                                        name="field_cell_phone"
                                                        ngModel>
                                                    </ngx-intl-tel-input>
                                                </div>


                                                <div class="col-md-6" *ngIf="showFiscalCode">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>{{ 'PAYMENTS.FISCAL_CODE' | translate }}</mat-label>
                                                        <input ngModel name="field_fiscal_code" maxlength="16" matInput>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <!-- Partner address -->
                                            <div ngModelGroup="field_address" #partnerAddress="ngModelGroup">

                                                <input
                                                    class="d-none"
                                                    name="multiple_properties"
                                                    matInput
                                                    ngModel="true">

                                                <mat-expansion-panel class="mt-4">
                                                    <mat-expansion-panel-header>
                                                        <mat-panel-title class="h6 text-uppercase text-muted fw-semibold mb-0">Partner address</mat-panel-title>
                                                        <mat-panel-description class="text-truncate">{{ addressSummary(partnerAddress.value) || 'Optional' }}</mat-panel-description>
                                                    </mat-expansion-panel-header>
                                                    <div class="d-flex justify-content-end mb-2">
                                                        <button type="button" mat-stroked-button color="primary" (click)="copyAddress()">
                                                            <mat-icon>content_copy</mat-icon>
                                                            Copy Address
                                                        </button>
                                                    </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <mat-form-field class="full-width-field">
                                                            <mat-label>Street Address</mat-label>
                                                            <input ngModel name="address_line1" matInput>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-md-5">
                                                        <mat-form-field class="full-width-field">
                                                            <mat-label>City</mat-label>
                                                            <input ngModel name="locality" matInput>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-md-5">
                                                        <mat-form-field class="full-width-field">
                                                            <mat-label>{{ administrativeAreaLabelPartner }}</mat-label>
                                                            <mat-select matInput ngModel name="administrative_area" *ngIf="internationalAddressService.hasAdministrativeAreas(selectedCountryPartner)">
                                                                <mat-option>None</mat-option>
                                                                <mat-option *ngFor="let area of internationalAddressService.getAdministrativeAreas(selectedCountryPartner)"
                                                                    [value]="area.abbreviation">
                                                                    {{ area.name }}</mat-option>
                                                            </mat-select>
                                                            <input matInput ngModel name="administrative_area" *ngIf="!internationalAddressService.hasAdministrativeAreas(selectedCountryPartner)">
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-md-2">
                                                        <mat-form-field class="full-width-field">
                                                            <mat-label>{{ postalCodeLabelPartner }}</mat-label>
                                                            <input ngModel name="postal_code" matInput>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-12">
                                                        <mat-form-field class="full-width-field">
                                                            <mat-label>Country</mat-label>
                                                            <mat-select [(ngModel)]="selectedCountryPartner" name="country_code" (ngModelChange)="onCountryChangePartner($event)">
                                                                <mat-option *ngFor="let country of this._fieldsService.countries" [value]="country.abbreviation">
                                                                    {{ country.name }}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                </mat-expansion-panel>
                                            </div>

                                            <div class="row mt-3">
                                                <div class="col-12">
                                                    <p class="small mb-1">Consenting below permits Arthur Murray International, Inc. to send you text messages about appointments, updates, and promotional offers. No purchase is necessary, and you can opt out anytime by texting STOP. Message and data rates may apply.</p>
                                                    <mat-checkbox [ngModel]="field_communication_opt_in_partner" (ngModelChange)="onCommunicationOptInPartnerChange($event)" name="field_communication_opt_in_partner" class="small">
                                                        Consent Given
                                                    </mat-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </mat-card>
                            </div>



                            <div class="row">

                                <div class="col-12">
                                    <h3 class="mt-3">Additional Details</h3>
                                </div>

                                <div class="col-4">
                                    <mat-form-field class="full-width-field">
                                        <mat-label>Inquiry Taker</mat-label>
                                        <mat-select matInput required ngModel name="field_inquiry_taker">
                                            <mat-option>None</mat-option>
                                            <mat-option *ngFor="let element of this._fieldsService.instructorData()"
                                                [value]="element.uid">
                                                {{ element.value }}</mat-option>
                                        <mat-option *ngFor="let element of this._fieldsService.systemUsers()" [value]="element.uid">
                                            {{ element.value }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-4">
                                    <mat-form-field class="full-width-field">
                                      <mat-label>Type of Dances</mat-label>
                                      <mat-select multiple
                                        name="field_dances_type"
                                        ngModel
                                        >
                                        <mat-option>None</mat-option>
                                        <mat-option
                                        *ngFor="let element of this._fieldsService.dance_types"
                                        [value]="element.key">{{ element.value }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-4">
                                    <mat-form-field class="full-width-field">
                                        <mat-label>How did you hear about us?</mat-label>
                                        <mat-select
                                            ngModel
                                            name="field_inquiry_method">
                                            <mat-option>None</mat-option>
                                            <mat-option
                                            *ngFor="let element of this._fieldsService.field_inquiry_method"
                                            [value]="element.key">{{ element.value }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="mt-1 mb-3">
                                    <!-- This should be hidden and selected in the Student Inquiry Form  -->
                                    <mat-checkbox
                                        matTooltip="Inquired students are new students to the studio."
                                        [matTooltipPosition]="'right'"
                                        [ngModel]="this?.['inquiry']"
                                        name="field_inquiry_studen"
                                        class="">Inquiry</mat-checkbox>
                                </div>

                                <div class="col-12">
                                    <h3 class="mt-3">Schedule First Lesson</h3>
                                </div>

                                <div class="col-4">
                                    <mat-form-field class="full-width-field">
                                        <mat-label>Teacher</mat-label>
                                        <mat-select matInput ngModel name="field_teacher">
                                            <mat-option>None</mat-option>
                                            <mat-option *ngFor="let element of this._fieldsService.instructorData()"
                                                [value]="element.uid">
                                                {{ element.value }}</mat-option>
                                        <mat-option *ngFor="let element of this._fieldsService.systemUsers()" [value]="element.uid">
                                            {{ element.value }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-4">
                                    <mat-form-field class="full-width-field">
                                        <mat-label>Lesson Type</mat-label>
                                        <mat-select ngModel name="lesson_type">
                                            <mat-option>None</mat-option>
                                            <mat-option
                                                *ngFor="let element of this._taxonomyService.lesson_type"
                                                [value]="element.id">{{ element.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>


                                <div class="col-4">
                                    <mat-form-field class="full-width-field">
                                        <mat-label>Requested Date and Time</mat-label>
                                        <input
                                            [(ngModel)]="field_date_and_time"
                                            name="requested_date_time"
                                            matInput
                                            type="text"
                                            appFlatpickrDatetime
                                            [enableTime]="true"
                                            [minuteIncrement]="15"
                                            [setCurrentTimeOnOpen]="true"
                                            [closeOnSelect]="false"
                                            readonly>
                                        <mat-icon matSuffix>calendar_today</mat-icon>
                                    </mat-form-field>
                                </div>

                                <div class="col-12">
                                    <mat-form-field class="full-width-field">
                                        <mat-label>Notes</mat-label>
                                        <textarea ngModel name="field_notes" matInput placeholder=""></textarea>
                                    </mat-form-field>
                                </div>

                                <!-- <div class="col-6">
                                    <mat-form-field class="full-width-field">
                                        <mat-label>Low Lesson Threshold</mat-label>
                                        <input
                                            name="field_low_lesson_threshold"
                                            matInput
                                            type="number"
                                            ngModel>
                                    </mat-form-field>
                                </div> -->

                            </div>

                            <app-error-message [message]=this.errorMessage></app-error-message>

                            <button
                            *ngIf="!embedded"
                            [disabled]="!canSubmit"
                            type="button"
                            (click)="onSubmit(f);"
                            mat-raised-button
                            color="accent">Create Student Account</button>
                        </div>
                </form>
            </div>


</div>

<mat-dialog-actions align="end">
    <ng-container *ngIf="this.actionType === 'create'">
    </ng-container>
    <ng-container *ngIf="this.actionType === 'edit'">
        <ng-container *ngIf="this.initActionType == 'edit'">
            <button type="button" (click)="setFormMode('delete')" mat-raised-button color="accent">Delete</button>
            <button type="button" (click)="onSubmit(f);" mat-raised-button color="primary">Save</button>
        </ng-container>
        <ng-container *ngIf="this.initActionType == 'create'">
            <button type="button" (click)="closeDialog()" mat-raised-button color="accent">Cancel</button>
            <button type="button" (click)="onSubmit(f);" mat-raised-button color="primary">Save</button>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="this.actionType === 'delete'">
        <button (click)="setFormMode('edit')" type="submit" mat-raised-button color="accent">Cancel</button>
        <button (click)="onDeleteSubmit(this._injectedDialogData['data']['EntityID'])" type="submit" mat-raised-button
            color="accent">Delete</button>
    </ng-container>
</mat-dialog-actions>
